export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
export const DATE_FORMAT = 'yyyy-MM-dd';
export const DEFAULT_PRESENTATION = 'separate'; // or 'mixed'. Default search presentation
export const DEFAULT_RESOURCES_LIMIT = 1000;
